// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import Es6Promise from 'es6-promise'
Es6Promise.polyfill()
import App from './App'
import router from './router'
import store from './store'

import 'element-ui/lib/theme-chalk/index.css';

import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
Vue.use(ViewUI);

import { Select,Option, Rate } from 'element-ui';
Vue.use(Select)
Vue.use(Option)
Vue.use(Rate)
//引入工具类
import util from './libs/util';
Vue.prototype.$util = util;

Vue.config.productionTip = false

//API的地址
Vue.prototype.$API_URL = process.env.API_URL;

import VueCookies from 'vue-cookies';
Vue.use(VueCookies);
Vue.$cookies.config("12h");

//引入复制的控件
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

//引入i18n
import VueI18n from 'vue-i18n'
import VueI18nFilter from 'vue-i18n-filter'
import i18nDictionary from "@/i18n"

Vue.use(VueI18n)
Vue.use(VueI18nFilter)
Vue.locale = () => { };


const i18n = new VueI18n({
  locale: Vue.$cookies.get("kls_user_language") == null ? util.langCheck("cn") : util.langCheck(Vue.$cookies.get("kls_user_language")), // set locale
  messages: i18nDictionary, // set locale messages
})
Vue.use(ViewUI, {
  i18n: (key, value) => i18n.t(key, value)
});

Vue.prototype._i18n = i18n


//引入枚举类 新增语言
import enums from './libs/enums';
Vue.prototype.$enums = enums;

//引入meetingzen样式
import '../static/css/meetingzen.less';

//引入全局filter
import filters from "./libs/filters"
Object.keys(filters).forEach(o => Vue.filter(o, filters[o]));

import Search from '@/components/Search'
Vue.component(Search.name, Search)

import TagList from '@/components/tagList'
Vue.component(TagList.name, TagList)


// 引入组件
// import tinymce from 'tinymce/tinymce'
// import tinymceEditor from '@tinymce/tinymce-vue'
// Vue.component('editor',tinymceEditor)

// 全局注册图片组件
import vImage from "@/components/v_image"
Vue.component("v-image", vImage)



import icons from "@/components/icons"
Vue.use(icons)

import {  Slider } from 'element-ui';
Vue.use(Slider)
// 引入高亮组件
import TextHighlight from 'vue-text-highlight';
Vue.component('text-highlight', TextHighlight);

// 引入瀑布流插件
import {VueMasonryPlugin} from 'vue-masonry';
Vue.use(VueMasonryPlugin)

// // 引入wangEditor
import wangEditor from '@/components/my_editor'
Vue.component(wangEditor.name, wangEditor)

// 引入自定义滚动条组件
import customScroll from "@/components/custom_scroll"
Vue.component("custom-scroll", customScroll)
// Vue.component('wang-editor', wangEditor);
// Vue.component('Toolbar', Toolbar);

// 图片预览组件
import hevueImgPreview from '@/components/hevue-img-preview'
Vue.use(hevueImgPreview)

import v_upload_video from "@/components/v_upload_video"
Vue.use(v_upload_video)

/* eslint-disable no-new */
export default new Vue({
  el: '#app',
  router,
  i18n,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js